import {
  Box,
  Typography,
  Container,
  Button,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isLoggedInAtom } from "../atoms/auth";

// Icons
import MailIcon from "@mui/icons-material/Mail";
import DvrIcon from "@mui/icons-material/Dvr";
import SearchIcon from "@mui/icons-material/Search";

const HomePage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const userLoggedIn = useAtomValue(isLoggedInAtom);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: theme.palette.background.default,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: "center",
            py: 8,
          }}
        >
          {/* Icon */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 80,
              height: 80,
              borderRadius: "20px",
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 8px 32px ${alpha(
                theme.palette.primary.main,
                0.25
              )}`,
              mb: 4,
            }}
          >
            <MailIcon sx={{ fontSize: 40, color: "white" }} />
          </Box>

          {/* Main Heading */}
          <Typography
            variant="h2"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: "2.5rem", sm: "3rem", md: "3.5rem" },
              color: "text.primary",
              letterSpacing: "-0.02em",
              mb: 2,
            }}
          >
            MailFlow Monitor
          </Typography>

          {/* Subtitle */}
          <Typography
            variant="h6"
            sx={{
              color: "text.secondary",
              fontWeight: 400,
              maxWidth: "600px",
              mx: "auto",
              mb: 5,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              lineHeight: 1.6,
            }}
          >
            {userLoggedIn
              ? "Monitor email flows and track deliveries in real-time"
              : "Your centralized email monitoring platform. Sign in to get started."}
          </Typography>

          {/* CTA Buttons */}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
          >
            {userLoggedIn ? (
              <>
                <Button
                  variant="contained"
                  size="large"
                  startIcon={<DvrIcon />}
                  onClick={() => navigate("/logs/email-flow")}
                  sx={{
                    py: 1.5,
                    px: 4,
                    fontSize: "1rem",
                    fontWeight: 600,
                    borderRadius: 2,
                    boxShadow: "none",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: `0 8px 20px ${alpha(
                        theme.palette.primary.main,
                        0.3
                      )}`,
                    },
                  }}
                >
                  View Logs
                </Button>
              </>
            ) : (
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/login")}
                sx={{
                  py: 1.5,
                  px: 5,
                  fontSize: "1rem",
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: "none",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: `0 8px 20px ${alpha(
                      theme.palette.primary.main,
                      0.3
                    )}`,
                  },
                }}
              >
                Sign In to Continue
              </Button>
            )}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default HomePage;
